import { TableColumnsType } from "antd";
import { useCallback, useMemo } from "react";
import { User } from "../../../../types/user";
import DropdownOptionsUsers from "../components/DropdownOptionsUsers/DropdownOptionsUsers";

type Options = {
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

export default function useTableUsers({ onModify, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<User> = [
      {
        title: "NOM COMPLET",
        dataIndex: "fullname",
        key: "fullname",
        align: "left",
        width: 200,
        className: "table-events-column",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "EMAIL",
        dataIndex: "email",
        key: "email",
        align: "center",
        width: 100,
        className: "table-events-column",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "ROLE",
        dataIndex: ["cached_role", "displayName"],
        align: "center",
        key: "3",
        width: 110,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        dataIndex: "",
        align: "center",
        key: "4",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsUsers
            itemId={item.id}
            onModify={onModify}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [onModify, onDelete]);

  const onRowClick = useCallback(
    (record: User) => {
      return {
        onClick: () => onModify(record.id),
      };
    },
    [onModify],
  );

  return { columns, onRowClick };
}
